// 메인 헤더 공통 틀 — 헤더는 그대로 두고 아래 화면만 바뀜 (2026-11-01 mid=470: /round 등 이동 때 헤더까지 깜박이던 것).
// 화면 파일을 받아오는 동안 Suspense 대기도 이 틀 안에서만 → 헤더는 계속 보임.
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader, SiteSkipLink } from '@widgets/site-layout';

export function SiteShell() {
  return (
    <>
      <SiteSkipLink />
      <SiteHeader />
      <Suspense fallback={<div style={{ minHeight: '60vh' }} aria-busy="true" />}>
        <Outlet />
      </Suspense>
    </>
  );
}
